/*
 * @description: 系统路由配置
 * @author: Vincent
 * @since: 2022-06-21 11:03:46
 * @version: 1.0
 */

import HomeLayout from "@/app/home/views/components/HomeLayout.vue";
export default [
  {
    path: "/personal-center",
    redirect: "/personal-center/index",
    component: HomeLayout,
    meta: {
      title: 'module.personal-center.098676-0',
      icon: "guide",
      keepAlive: true,
      whiteList: true,
    },
    children: [
      // 首页
      {
        path: "index",
        component: () => import("@/app/home/views/personal-center"),
        name: "PersonalIndex",
        meta: {
          title: 'module.personal-center.098676-0',
          icon: "guide",
          keepAlive: true,
          breadcrumb: true,
          whiteList: true,
        },
      },
      {
        path: "company",
        component: () => import("@/app/home/views/company-center"),
        name: "company",
        meta: {
          title: 'module.personal-center.098676-1',
          icon: "guide",
          keepAlive: true,
          breadcrumb: true,
          whiteList: true,
        },
      },
    ],
  },
  {
    path: "/user-center",
    redirect: "/index",
    component: HomeLayout,
    children: [
      // 首页
      {
        path: "index",
        component: () => import("@/app/home/views/user-center"),
        name: "UserIndex",
        meta: {
          title: 'module.personal-center.098676-2',
          icon: "guide",
          keepAlive: true,
          breadcrumb: true,
          whiteList: true,
        },
      },
    ],
  },
  {
    path: "/home-service-center",
    redirect: "/changePassword",
    component: HomeLayout,
    meta: {
      title: 'module.personal-center.098676-3',
      icon: "guide",
      // keepAlive: true,
      whiteList: true,
    },
    children: [
      {
        path: "changePassword",
        component: () =>
          import("@/app/home/views/serviceCenter/changePassword"),
        name: "changePassword",
        meta: {
          title: 'module.personal-center.098676-4',
          icon: "guide",
          keepAlive: true,
          breadcrumb: true,
          whiteList: true,
        },
      },
      {
        path: "changePhone",
        component: () => import("@/app/home/views/serviceCenter/changePhone"),
        name: "changePhone",
        meta: {
          title: 'module.personal-center.098676-5',
          icon: "guide",
          keepAlive: true,
          breadcrumb: true,
          whiteList: true,
        },
      },
      {
        path: "agreement",
        component: () => import("@/app/home/views/serviceCenter/agreement"),
        name: "agreement",
        meta: {
          title: 'module.personal-center.098676-6',
          icon: "guide",
          keepAlive: true,
          breadcrumb: true,
          whiteList: true,
        },
      },
      {
        path: "myOrder",
        component: () => import("@/app/home/views/myOrder"),
        name: "myOrder",
        meta: {
          title: 'module.personal-center.098676-7',
          icon: "guide",
          keepAlive: true,
          breadcrumb: true,
          whiteList: true,
        },

      },
      // 我的绩效
      {
        path: "achieve",
        component: () => import("@/app/achieve/index"),
        name: "achieve",
        meta: {
          title: 'module.personal-center.098676-8',
          icon: "guide",
          keepAlive: true,
          whiteList: true,
        },
      },
      // 绩效详情
      {
        path: "achieveDetail",
        component: () => import("@/app/achieve/detail"),
        name: "achieveDetail",
        meta: {
          title: 'module.personal-center.098676-9',
          icon: "guide",
          keepAlive: true,
          whiteList: true,
        },
      },
      // 寻源单
      {
        path: "source",
        component: () => import("@/app/quotedPrice/source"),
        name: "source",
        meta: {
          title: 'module.personal-center.098676-10',
          icon: "guide",
          whiteList: true,
        },
      },
      // 我的报价
      {
        path: "quotedPrice",
        component: () => import("@/app/quotedPrice/index"),
        name: "quotedPrice",
        meta: {
          title: 'module.personal-center.098676-11',
          icon: "guide",
          whiteList: true,
        },
      },
      // 我的报价编辑
      {
        path: "quotedPriceAdd",
        component: () => import("@/app/quotedPrice/add"),
        name: "quotedPriceAdd",
        meta: {
          title: 'module.personal-center.098676-12',
          icon: "guide",
          whiteList: true,
          isSupplierCodeRequired: true
        },
      },
      // 我的招标报价编辑
      {
        path: "quotedPriceSource",
        component: () => import("@/app/quotedPrice/source"),
        name: "quotedPriceSource",
        meta: {
          title: 'module.personal-center.098676-13',
          icon: "guide",
          whiteList: true,
          isSupplierCodeRequired: true
        },
      },
      // 我的代办
      {
        path: "myAgent",
        component: () => import("@/app/home/views/serviceCenter/myAgent"),
        name: "myAgent",
        meta: {
          title: 'module.personal-center.098676-14',
          icon: "guide",
          whiteList: true,
        },
      },
    ],
  },
];
